import { ReactiveMicrocomponent } from "../ReactiveMicrocomponent";
import { AbstractTimer } from "./AbstractTimer";
import { Mode } from "./Mode";

export class RepeatingTimer extends AbstractTimer {
  public constructor(name: string, initialDelay: number | null, frequencyInput: ReactiveMicrocomponent<number>) {
    super(name, Mode.REPEATING, initialDelay, frequencyInput);
  }
}
